import React, { useEffect } from "react";
// import CardPreview2 from "../../components/Merchandise/CardPreview2";
import MerchandiseDescription from "../../components/Merchandise/MerchandiseDescription";

const AddMerchantNameDes = (props) => {


    useEffect(() => {
        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="d-flex flex-column justify-content-start py-2 px-4 bg-light">
            <div className="d-flex flex-row mt-2 gap-2">
                <div className="width-65" >
                    <MerchandiseDescription lang={props?.lang} />
                </div>
                {/* <div className="width-35" >
                  <CardPreview2/>
                </div> */}

            </div>

        </div>
    );
};

export default AddMerchantNameDes;
